// @flow
import { completeSignUpModal, OPEN_SIGN_UP_MODAL } from './modal';
import { fetchBidderDataIfNeeded, getUserData } from './user';
import { bidderExistsSuccess } from './bidderExists';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { getRegisterAccountAnalytics } from './analytics';
import type { GlobalState } from '../rootReducer';
import { postCreateAccount } from '../api/bidder';

/* Action Types */
export const CREATE_ACCOUNT_FAIL = 'la/ui/createAccount/FAIL';
export const CREATE_ACCOUNT_REQUEST = 'la/ui/createAccount/REQUEST';
export const CREATE_ACCOUNT_SUCCESS = 'la/ui/createAccount/SUCCESS';
export const CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS = 'la/ui/createAccount/LOG_ANALYTICS';

// reducer
const DEFAULT_STATE = {
    error: null,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case CREATE_ACCOUNT_FAIL:
            return {
                ...state,
                error: action.payload,
                submitted: false,
                success: false,
            };
        case CREATE_ACCOUNT_REQUEST:
            return {
                ...state,
                error: null,
                submitted: true,
                success: false,
            };
        case CREATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                error: null,
                submitted: false,
                success: true,
            };
        case OPEN_SIGN_UP_MODAL:
            return {
                ...state,
                error: null,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.createAccount;

export const getCreateAccountState = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const submitCreateAccount = (emailAddress: string, agree: any, attributionData: any) => async (
    dispatch: Function,
    getState: Function,
) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        const forceFetchBidderData = true;
        dispatch({
            payload: emailAddress,
            type: CREATE_ACCOUNT_REQUEST,
        });

        const response = await postCreateAccount({ agree, deployment, emailAddress });
        const token = response.payload.createToken;

        dispatch(completeSignUpModal());
        dispatch({
            meta: { actionTime: Date.now() },
            payload: token,
            type: CREATE_ACCOUNT_SUCCESS,
        });
        dispatch(fetchBidderDataIfNeeded(token, forceFetchBidderData)).then(() => {
            const userData = getUserData(getState());
            dispatch({
                meta: {
                    ...getRegisterAccountAnalytics(getState(), userData.bidderId, attributionData),
                    actionTime: Date.now(),
                },
                payload: userData,
                type: CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS,
            });
        });
    } catch (error) {
        if (error === 'User Already Exists') {
            dispatch(bidderExistsSuccess(emailAddress));
        }

        dispatch({
            error: true,
            meta: { emailAddress },
            payload: error,
            type: CREATE_ACCOUNT_FAIL,
        });
    }
};
